module.exports = __webpack_public_path__ + "static/media/ly.2441391f.svg";